import { render, staticRenderFns } from "./DataViewSidebarIngredients.vue?vue&type=template&id=3d9831c7&scoped=true"
import script from "./DataViewSidebarIngredients.vue?vue&type=script&lang=js"
export * from "./DataViewSidebarIngredients.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebarIngredients.vue?vue&type=style&index=0&id=3d9831c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9831c7",
  null
  
)

export default component.exports